import firebase from "../firebase";

export default function({ officeId, visitId, stageId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "moveToStage",
        data: { officeId, visitId, stageId }
    });
}
